module.exports = __webpack_public_path__ + "static/media/sort-up.28106c4a.svg";